var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 7.71875C13.75 8.01042 14 8.4375 14 9C14 9.5625 13.75 9.98958 13.25 10.2812L2.25 16.7812C1.77083 17.0729 1.27083 17.0729 0.75 16.7812C0.25 16.5104 0 16.0833 0 15.5V2.5C0 1.875 0.260417 1.4375 0.78125 1.1875C1.32292 0.916667 1.8125 0.927083 2.25 1.21875L13.25 7.71875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.8fda1f05c2f8c3012c2fdd6b7d495f01.svg";
export { ForwardRef as ReactComponent };